import { ChatApi } from '@quicktools/shared-components/services/chatApi';

import { QUICKTOOLS_API_BASE_URL, RECAPTCHA_SITE_KEY } from '../../configs';

class SingleToolsChatApi extends ChatApi {
  constructor() {
    super({
      baseUrl: QUICKTOOLS_API_BASE_URL,
      recaptchaToken: RECAPTCHA_SITE_KEY,
      timeout: 600000,
    });
  }
}

export default new SingleToolsChatApi();
